import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../context/axios";
import { FaStar, FaRegStar } from "react-icons/fa";
import { Toaster, toast } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import ReviewModal from "./ReviewModal";
const STATUS_STYLES = {
  pending: "bg-yellow-100 text-yellow-800",
  booked: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
  done: "bg-green-300 text-green-900",
};

const UserBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [existingReviews, setExistingReviews] = useState({});

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const openReviewModal = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const closeReviewModal = () => {
    setSelectedBooking(null);
    setIsModalOpen(false);
  };

  // const handleSubmitReview = async (reviewData) => {
  //   setLoading(true);
  //   setSuccess("");

  //   const user = JSON.parse(localStorage.getItem("user") || "{}");
  //   if (!user._id) {
  //     setLoading(false);
  //     throw new Error("User not logged in");
  //   }

  //   try {
  //     const payload = {
  //       ...reviewData,
  //       userId: user._id,
  //     };

  //     const response = await axios.post("/reviews/add-reviews", payload);
  //     setSuccess("Review submitted successfully!");
  //     setIsModalOpen(false); // close only on success
  //   } catch (err) {
  //     // throw error so ReviewModal handles it and keeps form state
  //     throw err;
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSubmitReview = async (reviewData) => {
    setLoading(true);
    setSuccess("");
  
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    if (!user._id) {
      setLoading(false);
      throw new Error("User not logged in");
    }
  
    try {
      const payload = {
        ...reviewData,
        userId: user._id,
      };
  
      const response = await axios.post("/reviews/add-reviews", payload);
  
      // Update local review state instantly
      setExistingReviews((prev) => ({
        ...prev,
        // [selectedBooking.tourId._id]: response.data.review || true, // true fallback
        [selectedBooking.tourId._id]: response.data.review

      }));
  
      setSuccess("Review submitted successfully!");
      setIsModalOpen(false);
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };
  const fetchBookings = async (pageNumber = 1) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?._id) {
      toast.error("Please login first");
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(
        `/tours/userReservations/${user._id}?page=${pageNumber}`
      );
      setBookings(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
      const tourIds = res.data.data.map(b => b.tourId._id);
const reviewsRes = await axios.post("/reviews/get-by-tours", { tourIds });
setExistingReviews(reviewsRes.data.reviews || {});
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch bookings");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchBookings(page);
  }, [page]);

  const handleAddReview = (booking) => {
    console.log("Booking status:", booking.status); // Add this line to debug
    if (booking.status !== "done") {
      toast(
        "You can only add review & rating after the booking is completed.",
        { icon: "ℹ️" }
      );
      return;
    }
    toast.success(`Redirecting to add review for booking ID: ${booking._id}`);
  };

  if (loading)
    return (
      <div className="text-center mt-20 text-lg font-medium">
        Loading your bookings...
      </div>
    );

  if (bookings.length === 0)
    return (
      // <div className="text-center mt-20 text-lg font-medium">
      //   No bookings found for your account.
      // </div>
      <div className="h-[90vh] flex flex-col items-center justify-center text-center px-4 bg-white rounded-xl">
        <img
          src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
          alt="No data"
          className="w-24 h-24 mb-4 opacity-70"
        />
        <h2 className="text-2xl font-semibold text-gray-700 mb-2">
          No Bookings Yet
        </h2>
        <p className="text-gray-500 mb-6 max-w-md">
          You haven’t booked any packages yet. Start exploring and plan your
          next adventure with us!
        </p>
      </div>
    );

  return (
    <div className="p-4 max-w-full">

<div className="overflow-x-auto rounded-lg shadow">
<h1 className="text-3xl font-bold mb-6 text-gray-800">
        Your Booked Packages
      </h1>

      {/* <div className="overflow-x-auto border border-gray-300 rounded-md shadow-sm"> */}
      <table className="min-w-full border-collapse rounded-lg overflow-hidden shadow-lg">
        {" "}
        <thead className="bg-gray-300 text-white">
          <tr className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-left">
            <th className="py-2 px-3 text-left">#</th>
            <th className="py-2 px-3 text-left">Image</th>
            <th className="py-2 px-3 text-left">Package</th>
            <th className="py-2 px-3 text-left">Booking Date</th>
            <th className="py-2 px-3 text-left">Guests</th>
            <th className="py-2 px-3 text-left max-w-xs">Special Requests</th>

            <th className="py-2 px-3 text-left">Duration</th>
            <th className="py-2 px-3 text-left">Price/Person</th>
            <th className="py-2 px-3 text-left">Status</th>
            <th className="py-2 px-3 text-center">Review</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking, idx) => (
            <tr
              key={booking._id}
              className={`${
                idx % 2 === 0 ? "bg-white" : "bg-gray-50"
              } hover:bg-blue-100 transition`}
            >
              <td className="py-2 px-3 text-sm font-semibold">
                {(page - 1) * 10 + idx + 1}
              </td>

              <td className="py-2 px-3">
                {booking.tourId?.img ? (
                  <img
                    src={booking.tourId.img}
                    alt={booking.tourId.title || "Tour Image"}
                    className="w-20 h-12 object-cover rounded"
                  />
                ) : (
                  <span className="text-sm text-gray-400">No Image</span>
                )}
              </td>

              <td
                className="py-2 px-3 max-w-xs truncate"
                title={booking.tourId?.title}
              >
                {booking.tourId?.title || "N/A"}
              </td>

              <td className="py-2 px-3 text-sm font-mono">
                {new Date(booking.date).toLocaleDateString(undefined, {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
              </td>

              <td className="py-2 px-3 text-sm whitespace-pre-line">
                Adults: {booking.guests.adult || 0}
                <br />
                Children: {booking.guests.child || 0}
                <br />
                Infants: {booking.guests.infant || 0}
              </td>

              <td
                className="py-2 px-3 max-w-xs truncate"
                title={booking.specialRequest || "None"}
              >
                {booking.specialRequest || "None"}
              </td>

              <td className="py-2 px-3 text-sm font-mono">
                {booking.tourId?.duration
                  ? `${booking.tourId.duration.day}D / ${booking.tourId.duration.night}N`
                  : "N/A"}
              </td>

              <td className="py-2 px-3 text-green-700 font-semibold">
              €{booking.tourId?.price || "N/A"}
              </td>

              <td className="py-2 px-3">
                <span
                  className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                    STATUS_STYLES[booking.status] || STATUS_STYLES.pending
                  }`}
                >
                  {booking.status
                    ? booking.status.charAt(0).toUpperCase() +
                      booking.status.slice(1)
                    : "Pending"}
                </span>
              </td>

              {/* <td className="py-2 px-3 text-center">
                {booking.status === "done" ? (
                  <button
                    onClick={() => openReviewModal(booking)}
                    className="px-3 py-1 rounded text-white bg-blue-600 hover:bg-blue-700 cursor-pointer transition"
                    title="Add Review & Rating"
                  >
                    Add Review & Rating
                  </button>
                ) : booking.status === "received" ? (
                  <span className="px-3 py-1 rounded text-yellow-800 bg-yellow-100 font-semibold">
                    Pending
                  </span>
                ) : (
                  <button
                    disabled
                    className="px-3 py-1 rounded text-white bg-gray-400 cursor-not-allowed transition"
                    title="Review available after booking is completed"
                  >
                    Add Review & Rating
                  </button>
                )}
              </td> */}
              <td className="py-2 px-3 text-center">
  {booking.status === "done" ? (
    // existingReviews[booking.tourId?._id] ? (
      existingReviews[booking.tourId?._id]?.booking === booking._id ? (

      <div className="text-green-700 font-semibold"> Reviewed</div>
    ) : (
      <button
        onClick={() => openReviewModal(booking)}
        className="px-3 py-1 rounded text-white bg-blue-600 hover:bg-blue-700 cursor-pointer transition"
        title="Add Review & Rating"
      >
        Add Review & Rating
      </button>
    )
  ) : (
    <button
      disabled
      className="px-3 py-1 rounded text-white bg-gray-400 cursor-not-allowed transition"
      title="Review available after booking is completed"
    >
      Add Review & Rating
    </button>
  )}
</td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* </div> */}
      <ReviewModal
        isOpen={isModalOpen}
        onClose={closeReviewModal}
        onSubmit={handleSubmitReview}
        booking={selectedBooking}
      />
      {/* Pagination Controls */}
      <div className="mt-6 flex justify-center space-x-3">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          className="px-4 py-2 bg-blue-600 text-white rounded disabled:bg-gray-400 transition-colors"
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, idx) => (
          <button
            key={idx}
            onClick={() => setPage(idx + 1)}
            className={`px-4 py-2 rounded transition-colors ${
              page === idx + 1
                ? "bg-blue-700 text-white font-bold shadow-md"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            {idx + 1}
          </button>
        ))}

        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          className="px-4 py-2 bg-blue-600 text-white rounded disabled:bg-gray-400 transition-colors"
        >
          Next
        </button>
      </div>

      <Toaster position="top-right" />
      </div>
    </div>
  );
};

export default UserBookings;

// const handleSubmitReview = async (reviewData) => {
//   setLoading(true);
//   setError("");
//   setSuccess("");

//   try {
//     // Get user ID from localStorage (assuming user stored as JSON string with _id)
//     const user = JSON.parse(localStorage.getItem("user") || "{}");
//     if (!user._id) throw new Error("User not logged in");

//     // Add userId to review data
//     const payload = {
//       ...reviewData,
//       userId: user._id,
//     };

//     // Call backend API to submit review
//     const response = await axios.post("/reviews/add-reviews", payload);
//     setSuccess("Review submitted successfully!");
//     setIsModalOpen(false);
//   } catch (err) {
//     setError(err.response?.data?.message || err.message || "Failed to submit review");
//   } finally {
//     setLoading(false);
//   }
// };
